import React from "react";

function Flower({ fill, className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
      viewBox="-5.0 -2.3 471.8 417.4"
      zoomAndPan="magnify"
      style={{ fill: "rgb(0, 0, 0)", display: "none" }}
      role="img"
      aria-label="Beautiful Flower Petals"
    >
      <g
        fillRule="evenodd"
        id="__id497_s23gcykd0y"
        opacity=".4"
        style={{ fill }}
      >
        <path
          d="m205.84 154.94c-9.4428-62.952-61.538-87.745-82.467-96.946-18.603-8.1783-22.663-23.292-22.663-23.292s-5.0362 16.997-5.0362 25.181c0 8.1838-1.8886 46.585 13.22 78.69 15.108 32.106 61.064 43.437 74.284 59.175s8.1838 43.437 8.1838 43.437-0.62952-22.033-15.738-35.253-52.25-13.22-73.024-50.991-22.539-108.23-4.4066-134.72c8.8908-12.986 0.69217 6.8584 14.479 19.515 12.793 11.744 51.521 23.398 74.284 46.585 25.957 26.44 19.515 69.877 18.886 68.618z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m176.92 180.66c5.4346-24.979 5.2699-36.327-9.836-52.067-15.411-16.058-30.434-10.699-47.54-39.122 8.8979 34.536 30.972 31.921 43.276 50.918 12.023 18.564 12.868 39.591 14.1 40.271z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m225.26 152.34c24.35-7.7831 34.095-13.6 40.174-34.552 6.2017-21.376-5.9515-31.706 10.111-60.732-25.46 24.974-12.158 42.783-22.459 62.937-10.065 19.694-27.853 30.939-27.826 32.347z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m275.26 178.51c18.915 17.196 28.825 22.727 50.01 17.516 21.612-5.317 24.482-21.007 57.651-21.61-34.358-9.5621-43.13 10.862-65.735 12.019-22.088 1.1303-40.72-8.6516-41.926-7.9247z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m278.75 238.95c-5.4346 24.979-5.2699 36.327 9.836 52.068 15.411 16.058 30.434 10.699 47.54 39.122-8.8979-34.536-30.972-31.921-43.276-50.918-12.023-18.564-12.868-39.591-14.1-40.271z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m234.19 267.9c-24.35 7.7831-34.095 13.6-40.174 34.552-6.2017 21.376 5.9516 31.706-10.111 60.732 25.46-24.974 12.158-42.783 22.459-62.937 10.065-19.694 27.853-30.939 27.826-32.347z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m188.59 241.73c-18.915-17.196-28.825-22.727-50.01-17.516-21.612 5.317-24.482 21.007-57.651 21.609 34.358 9.5622 43.13-10.862 65.735-12.019 22.088-1.1303 40.72 8.6516 41.926 7.9248z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m264.41 160.7c49.797-39.654 45.22-97.166 42.724-119.89-2.2187-20.2 8.8403-31.273 8.8403-31.273s-17.238 4.1371-24.325 8.229c-7.0874 4.0919-41.288 21.657-61.538 50.794s-7.0858 74.601-14.105 93.919c-7.0196 19.318-33.526 28.806-33.526 28.806s18.767-11.562 22.661-31.256c3.8946-19.694-14.676-51.86 7.6475-88.737s82.462-73.636 114.47-71.175c15.692 1.2066-5.5934 4.0286-9.6611 22.297-3.7744 16.951 5.497 56.318-3.2017 87.624-9.9193 35.699-50.758 51.839-49.982 50.664z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m289.53 212.42c59.24 23.298 106.76-9.4209 125.19-22.946 16.384-12.021 31.503-7.9804 31.503-7.9804s-12.202-12.86-19.289-16.952c-7.0873-4.0919-39.399-24.928-74.758-27.896-35.359-2.9684-68.149 31.164-88.389 34.744-20.24 3.5798-41.709-14.631-41.709-14.631s19.396 10.472 38.399 3.9971c19.003-6.4744 37.574-38.64 80.672-37.746 43.098 0.89465 105 34.596 118.87 63.543 6.801 14.193-6.2856-2.8298-24.14 2.7816-16.567 5.2068-46.024 32.919-77.485 41.039-35.876 9.2592-70.273-18.038-68.868-17.953z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m253.81 258.52c9.4428 62.952 61.538 87.745 82.467 96.946 18.603 8.1783 22.663 23.292 22.663 23.292s5.0361-16.997 5.0361-25.181c6.1e-5 -8.1838 1.8886-46.585-13.22-78.69-15.108-32.106-61.064-43.437-74.284-59.175s-8.1838-43.437-8.1838-43.437 0.62952 22.033 15.738 35.253 52.25 13.22 73.024 50.991 22.539 108.23 4.4066 134.72c-8.8908 12.986-0.69214-6.8583-14.479-19.515-12.793-11.744-51.521-23.398-74.284-46.585-25.957-26.44-19.515-69.877-18.886-68.618z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m196.78 252c-49.797 39.654-45.22 97.166-42.724 119.89 2.2187 20.2-8.8403 31.273-8.8403 31.273s17.238-4.1371 24.325-8.229c7.0874-4.0919 41.288-21.657 61.538-50.794s7.0858-74.601 14.105-93.919c7.0196-19.318 33.526-28.806 33.526-28.806s-18.767 11.562-22.661 31.256c-3.8946 19.694 14.676 51.86-7.6474 88.737-22.324 36.877-82.462 73.636-114.47 71.175-15.692-1.2065 5.5934-4.0286 9.6611-22.297 3.7744-16.951-5.497-56.318 3.2017-87.624 9.9193-35.699 50.758-51.839 49.982-50.664z"
          style={{ fill: "inherit" }}
        ></path>
        <path
          d="m172.32 200.95c-59.24-23.298-106.76 9.4208-125.19 22.946-16.384 12.021-31.503 7.9804-31.503 7.9804s12.202 12.86 19.289 16.952c7.0874 4.0919 39.399 24.928 74.758 27.896 35.358 2.9684 68.149-31.164 88.389-34.744 20.24-3.5798 41.709 14.631 41.709 14.631s-19.396-10.471-38.399-3.9971c-19.003 6.4744-37.574 38.64-80.672 37.746-43.098-0.89465-105-34.596-118.87-63.542-6.801-14.193 6.2856 2.8297 24.14-2.7816 16.567-5.2067 46.024-32.919 77.485-41.039 35.876-9.2592 70.273 18.038 68.868 17.954z"
          style={{ fill: "inherit" }}
        ></path>
      </g>
    </svg>
  );
}

export default Flower;
